export default "__VITE_ASSET__BqGIAYHL__"